import Animation from "./animation"
import Contact from "./contact"
import Nav from "./nav"
import Search from "./search"
import Slider from "./slider"

document.addEventListener("DOMContentLoaded", function () {
    Animation(jQuery)
    Contact(jQuery)
    Nav(jQuery)
    Search(jQuery)
    Slider(jQuery)
})
